import {
  apiRequest,
  employeeCreate,
  masterRegion,
  masterReligion,
  masterBloodType,
  masterMaritalStatus,
  masterBank,
  masterEmployeeType,
  masterEmployeeStatus,
  masterEmployeeStatusDescription,
  masterEmployeeStatusPosition,
  masterWorkUnit,
  masterRank,
  masterPosition,
  masterEducation,
  masterEmployeeCategories,
  masterMinistries,
  polaKerjaList,
  checkEnrollExist,
  masterGajiwebSatker,
  masterGajiwebBankSpan,
} from "../../../../../services/adapters/kepegawaian/homeService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      employeeCreate,
      {
        body: query,
      },
      true
    );
  };

  fetchRegionCountry = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionProvince = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionCity = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchReligion = async (query) => {
    return await apiRequest(
      "get",
      masterReligion,
      {
        params: query,
      },
      true
    );
  };

  fetchBloodType = async (query) => {
    return await apiRequest(
      "get",
      masterBloodType,
      {
        params: query,
      },
      true
    );
  };

  fetchMaritalStatus = async (query) => {
    return await apiRequest(
      "get",
      masterMaritalStatus,
      {
        params: query,
      },
      true
    );
  };

  fetchBank = async (query) => {
    return await apiRequest(
      "get",
      masterBank,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeType = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeType,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeStatus = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeStatus,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeStatusDescription = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeStatusDescription,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeStatusPosition = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeStatusPosition,
      {
        params: query,
      },
      true
    );
  };

  fetchWorkUnit = async (query) => {
    return await apiRequest(
      "get",
      masterWorkUnit,
      {
        params: query,
      },
      true
    );
  };

  fetchDomicileProvince = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchDomicileCity = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchDomicileDistrict = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchDomicileVillage = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchIdentityProvince = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchIdentityCity = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchIdentityDistrict = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchIdentityVillage = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchEducation = async (query) => {
    return await apiRequest(
      "get",
      masterEducation,
      {
        params: query,
      },
      true
    );
  };

  fetchRank = async (query) => {
    return await apiRequest(
      "get",
      masterRank,
      {
        params: query,
      },
      true
    );
  };

  fetchPosition = async (query) => {
    return await apiRequest(
      "get",
      masterPosition,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeCategories = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeCategories,
      {
        params: query,
      },
      true
    );
  };

  fetchMinistries = async (query) => {
    return await apiRequest(
      "get",
      masterMinistries,
      {
        params: query,
      },
      true
    );
  };

  fetchPolaKerja = async (query) => {
    return await apiRequest(
      "get",
      polaKerjaList,
      {
        params: query,
      },
      true
    );
  };

  checkEnrollExist = async (query) => {
    return await apiRequest(
      "get",
      checkEnrollExist,
      {
        params: query,
      },
      true
    );
  };

  fetchSatkerGajiWeb = async (query) => {
    return await apiRequest(
      "get",
      masterGajiwebSatker,
      {
        params: query,
      },
      true
    );
  };

  fetchBankSpanGajiWeb = async (query) => {
    return await apiRequest(
      "get",
      masterGajiwebBankSpan,
      {
        params: query,
      },
      true
    );
  };
}

export default CreateRepository;
